export const blockIconsTextformattingDraftNew = (
	<span className='material-symbols-outlined'>draft</span>
);
